import { render, staticRenderFns } from "./AreaFormComponent.vue?vue&type=template&id=a7d2a7e2&"
import script from "./AreaFormComponent.vue?vue&type=script&lang=js&"
export * from "./AreaFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports